import React from 'react';

import { addWithConfig } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import ActionButton from 'components/action-button';
import { Box, Typography } from 'components/ui';
import type { BoxProps, TypographyProps } from 'components/ui';
import { useIsDesktopLargeBreakpoint } from 'hooks/use-media-query';
import { primitive, spacing } from 'styles/constants';

const styles = StyleSheet.create({
  imageContainer: {
    height: 216,
    marginTop: spacing.$16,
    overflow: 'hidden',
    width: '100%',
  },
  notAvailableContainer: {
    marginLeft: spacing.$4,
    marginRight: spacing.$4,
  },
  sectionTitle: {
    marginBottom: spacing.$6,
    marginTop: spacing.$8,
    textAlign: 'center',
  },
});

export const ImageContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.imageContainer, style] });

export const NotAvailableContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.notAvailableContainer, style] });

export const SectionTitle = ({ style, variant = 'headerOne', ...props }: TypographyProps) => {
  const isDesktopLarge = useIsDesktopLargeBreakpoint();

  return React.createElement(Typography, {
    ...props,
    variant,
    color: primitive.$bbqBrown,
    fontSize: isDesktopLarge && variant === 'headerOne' ? 30 : undefined,
    lineHeight: isDesktopLarge && variant === 'headerOne' ? 36 : undefined,
    style: [styles.sectionTitle, style],
  });
};

export const StyledActionButtonLink = addWithConfig(ActionButton).withConfig({
  style: { height: 48 },
});
